// extracted by mini-css-extract-plugin
module.exports = {"desktopContainer":"OneWay_desktopContainer__fphP_"};